module.exports = __webpack_public_path__ + "img/earthnav.69be6203.png";